import BaseApi from "@/core/HttpResources/BaseApi";
export default class PreguntaService {
    
    baseApiPublish = new BaseApi("Pregunta");

    async getByEvaluacionType(id: string|number): Promise<any> {
        return new Promise<any>((resolve, reject) =>
          this.baseApiPublish.request(
            "GET",
            "GetByEvaluationType/" + id,
            null,
            {},
            response => resolve(response.data),
            reject,
            () => {}
          )
        );
      }

 
}